import axios from "axios";

const configHeaders = {
  headers: {
    Authorization: "Bearer " + "yourJWTToken",
  },
};

async function connectApi({ method = "GET", url, payload }) {
  return await axios({
    method,
    url,
    data: payload,
    headers: configHeaders,
    responseType: "json",
  });
}

const baseURL = {
  submitForm: "/campaign_form_api/api/OlympicsGiveaway2024/PostForm",
};

export async function submitForm(payload) {
  const config = {
    method: "POST",
    url: baseURL.submitForm,
    payload,
  };
  return await connectApi(config);
}
